import {
  Button,
  GreyGrey70,
  SequenceMenu,
  IconEllipsisHorizontal,
  Center
} from '@sequencehq/core-components'
import { CancelAutomationMenuItem } from './CancelAutomation.menuItem'
import { useAutomationExecution } from 'Automations/hooks/useAutomationExecution'

export const AutomationExecutionKebabMenu = ({
  automationExecutionId
}: {
  automationExecutionId: string
}) => {
  const { automationExecution } = useAutomationExecution({
    executionId: automationExecutionId
  })

  if (automationExecution?.status !== 'RUNNING') {
    return null
  }

  return (
    <>
      <SequenceMenu
        width={226}
        data-testid="quote.menu"
        alignment="bottom-right"
        items={[
          <CancelAutomationMenuItem
            key="cancel-automation"
            automationExecutionId={automationExecution.id}
          />
        ]}
        menuButton={
          <Button variant="ghost" size="32px">
            <Center flexShrink="0">
              <IconEllipsisHorizontal color={GreyGrey70} />
            </Center>
          </Button>
        }
      />
    </>
  )
}
